import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import {
  GlobalMetadataSelectComponent
} from '../../../global-metadata/global-metadata-select/global-metadata-select.component';

@Component({
  selector: 'pixl-consumer-metadata',
  templateUrl: './consumer-metadata.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    GlobalMetadataSelectComponent
  ],
  standalone: true,
  styleUrls: ['../form-dialog-consumer.component.scss']
})
export class ConsumerMetadataComponent implements OnInit {
  @Input({ required: true }) parentForm!: FormGroup;

  consumerMetadataIdsArr: string[] = [];

  ngOnInit() {
    this.consumerMetadataIdsArr = this.consumerMetadata.controls.map(c => c.value.id);
  }

  get consumerMetadata(): FormArray {
    return this.parentForm.get('consumerMetadata') as FormArray;
  }
}
